import templateStr from 'has-text?ampclaims!./templates/policy-account-policy-summaries.html';
import _ from 'lodash';
import DateUtil from 'gw-portals-util-js/DateUtil';
import lobIconUtil from 'integration/platform/lobUtil/lobIconUtil';

/**
 * Get a policy icon or a policy type.
 * @param {String} policyType policy type.
 * @returns {String} name of a font-awesome icon.
 */
function getPolicyTypeIcon(policyType) {
    return lobIconUtil.getFontIcon(policyType);
}

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            gwPolicyAccountPoliciesSummary: '=',
            gwIdCardUrl: '=',
            gwPortalRoute: '=',
            hasRenewals: '='

        },
        controller: ['$scope', function ($scope) {
            var now = DateUtil.currentDate().getTime();

            $scope.getPolicyTypeIcon = getPolicyTypeIcon;
            $scope.hasRenewals = false;

            $scope.normalizedPeriods = _.memoize(function (gwPolicyAccountPoliciesSummary) {
                $scope.hasRenewals = false;
                var res = [];
                for (var i = 0; i < gwPolicyAccountPoliciesSummary.length; i++) {
                    var policy = gwPolicyAccountPoliciesSummary[i];
                    if (policy.periods.length > 0) {
                        var currentRenewed = policy.periods.length > 1;
                        $scope.hasRenewals = $scope.hasRenewals || currentRenewed;
                        res.push({
                            activePeriod: policy.periods[0],
                            hasRenewal: currentRenewed
                        });
                    }
                }
                return res;
            });

            $scope.isActive = function (line) {
                return new Date(line.activePeriod.effective).getTime() < now && !line.hasRenewal;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policy/common/directives/PolicyAccountPoliciesSummary.js
// module id = 2071
// module chunks = 0